import { render, staticRenderFns } from "./SVDLocationMapping.vue?vue&type=template&id=4baa2fd4&"
import script from "./SVDLocationMapping.vue?vue&type=script&lang=js&"
export * from "./SVDLocationMapping.vue?vue&type=script&lang=js&"
import style0 from "./SVDLocationMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports